"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateBookingTaxesDefaultExtraReducers = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const services_1 = tslib_1.__importDefault(require("../../../services"));
const getById_1 = tslib_1.__importDefault(require("../../saas/bookings/getById"));
const updateBookingTaxesDefault = toolkitRaw.createAsyncThunk('bookings/fetch_update_booking_taxes_default', async ({ id, override }, { rejectWithValue, getState, dispatch }) => {
    var _a, _b, _c, _d, _e;
    const updateModel = {
        data: {
            type: 'booking',
            attributes: {
                booking_items_attributes: [],
                booking_services_attributes: [],
            },
        },
    };
    try {
        const state = getState();
        let percentToUpdate = Number((_c = (_b = (_a = state.user) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.default_vat_percentage) || 0;
        const hasOverrideAttributes = Object.keys(override || {}).includes('percent');
        if (hasOverrideAttributes) {
            percentToUpdate = Number(override === null || override === void 0 ? void 0 : override.percent);
        }
        const bookingItemsStore = ((_d = state.bookings.booking.data) === null || _d === void 0 ? void 0 : _d.booking_items) || [];
        const bookingServicesStore = ((_e = state.bookings.booking.data) === null || _e === void 0 ? void 0 : _e.booking_services) || [];
        const bookingItems = bookingItemsStore.map((bookingItem) => {
            // The priority is the item vat
            // just if we are not reseting
            const itemPecent = bookingItem.item.vat_percentage;
            if (!hasOverrideAttributes && itemPecent > 0) {
                percentToUpdate = itemPecent;
            }
            return {
                ...bookingItem,
                vat_percentage: percentToUpdate,
            };
        });
        const bookingServices = bookingServicesStore.map((bookingService) => {
            return {
                ...bookingService,
                vat_percentage: percentToUpdate,
            };
        });
        updateModel.data.attributes.booking_items_attributes = bookingItems;
        updateModel.data.attributes.booking_services_attributes = bookingServices;
        const response = await services_1.default.patch(`/api/saas/me/bookings/${id}`, updateModel);
        await dispatch((0, getById_1.default)({ id: response.data.data.attributes.internal_id }));
        return null;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
    3;
});
const updateBookingTaxesDefaultExtraReducers = (builder) => {
    builder.addCase(updateBookingTaxesDefault.pending, (state) => {
        state.booking.slices.items.loading = true;
        state.booking.slices.services.loading = true;
    });
    builder.addCase(updateBookingTaxesDefault.fulfilled, (state) => {
        state.booking.slices.items.error = false;
        state.booking.slices.services.error = false;
        state.booking.slices.items.loading = false;
        state.booking.slices.services.loading = false;
    });
    builder.addCase(updateBookingTaxesDefault.rejected, (state) => {
        state.booking.slices.items.error = true;
        state.booking.slices.services.error = true;
        state.booking.slices.items.loading = false;
        state.booking.slices.services.loading = false;
    });
};
exports.updateBookingTaxesDefaultExtraReducers = updateBookingTaxesDefaultExtraReducers;
exports.default = updateBookingTaxesDefault;
//# sourceMappingURL=index.js.map